import React from 'react'

export type Props = {
  notifications: Nullable<Transformed.NotificationsByDisplayTarget>
}

export const defaultContext: Props = { notifications: null }

const NotificationsContext = React.createContext<Props>(defaultContext)
export default NotificationsContext
